import React, { useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import {
  countryoptions1,
  languageOptions,
  optiondeals,
  optionindustry,
  options,
  optionschoose,
  optionsource,
  optionssymbol,
} from "../../core/common/selectoption/selectoption";
import { leadsData } from "../../core/data/json/leads";
import { Modal } from "react-bootstrap";
import { TableData } from "../../core/data/interface";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import CollapseHeader from "../../core/common/collapse-header";
import { SelectWithImage2 } from "../../core/common/selectWithImage2";
import { all_routes } from "../router/all_routes";
import { TagsInput } from "react-tag-input-component";
import Offcanvas from "react-bootstrap/Offcanvas";
const CampaignRingless = () => {
  const route = all_routes;
  const [adduser, setAdduser] = useState(false);
  const [addcompany, setAddCompany] = useState(false);
  const [modalTitle, setModalTitle] = useState("Add New Lead");
  const data = leadsData;
  const [owner, setOwner] = useState(["Collab"]);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose2 = () => setShow(false);
  const handleShow2 = () => setShow(true);
  const handleClose3 = () => setShow(false);
  const handleShow3 = () => setShow(true);
  const togglePopup = (isEditing: any) => {
    setModalTitle(isEditing ? "Edit Lead" : "Add New Lead");
    setAdduser(!adduser);
  };
  const addcompanyPopup = () => {
    setAddCompany(!addcompany);
  };

  const [stars, setStars] = useState<{ [key: number]: boolean }>({});

  const handleStarToggle = (index: number) => {
    setStars((prevStars) => ({
      ...prevStars,
      [index]: !prevStars[index],
    }));
  };
  const columns = [
    {
      title: "",
      dataIndex: "",
      width:"90px",
      render: (text: string, record: any, index: number) => (
        <div
          className={`set-star rating-select ${stars[index] ? "filled" : ""}`}
          onClick={() => handleStarToggle(index)}
        >
          <i className="fa fa-star"></i>
        </div>
      ),
    },
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width:'132px',
        sorter: (a: TableData, b: TableData) =>
          a.company_name.length - b.company_name.length,
      },
    {
      title: "Total List",
      dataIndex: "totallist",
      key: "totallist",
      width:'132px',
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Dialled Leads/Total Leads",
      dataIndex: "totallead",
      key: "totallead",
      width:'132px',
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Hopper Count",
      dataIndex: "hoppercount",
      key: "hoppercount",
      width:'132px',
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Schedule time",
      dataIndex: "scheduletime",
      key: "scheduletime",
      width:'132px',
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Created date",
      dataIndex: "createddate",
      key: "createddate",
      width:'132px',
      sorter: (a: TableData, b: TableData) =>
        a.company_name.length - b.company_name.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: string) => (
        <div>
          {text === "Success" && (
            <span className="badge badge-pill badge-status bg-success">
              {text}
            </span>
          )}
          {text === "Pending" && (
            <span className="badge badge-pill badge-status bg-warning">
              {text}
            </span>
          )}
          {text === "Bounced" && (
            <span className="badge badge-pill badge-status bg-danger">
              {text}
            </span>
          )}
          {text === "Paused" && (
            <span className="badge badge-pill badge-status bg-info">
              {text}
            </span>
          )}
          {text === "Running" && (
            <span className="badge badge-pill badge-status bg-green">
              {text}
            </span>
          )}
        </div>
      ),
      sorter: true,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: "90px",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
               data-bs-target="#offcanvas_edit"
                          data-bs-toggle="offcanvas"
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>

            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_lead"
            >
              <i className="ti ti-trash text-danger"></i> Delete
            </Link>

            <Link className="dropdown-item" to="#">
              <i className="ti ti-clipboard-copy text-blue-light" /> clone
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const initialSettings = {
    endDate: new Date("2020-08-11T12:30:00.000Z"),
    ranges: {
      "Last 30 Days": [
        new Date("2020-07-12T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last 7 Days": [
        new Date("2020-08-04T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      "Last Month": [
        new Date("2020-06-30T18:30:00.000Z"),
        new Date("2020-07-31T18:29:59.999Z"),
      ],
      "This Month": [
        new Date("2020-07-31T18:30:00.000Z"),
        new Date("2020-08-31T18:29:59.999Z"),
      ],
      Today: [
        new Date("2020-08-10T04:57:17.076Z"),
        new Date("2020-08-10T04:57:17.076Z"),
      ],
      Yesterday: [
        new Date("2020-08-09T04:57:17.076Z"),
        new Date("2020-08-09T04:57:17.076Z"),
      ],
    },
    startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
    timePicker: false,
  };
  const [newContents, setNewContents] = useState<number[]>([0]);

  const addNewContent = () => {
    setNewContents([...newContents, newContents.length]);
  };

  const currency = [
    { value: "Choose", label: "Choose" },
    { value: "Dollar", label: "Dollar" },
    { value: "Euro", label: "Euro" },
    { value: "Pound", label: "Pound" },
    { value: "Rupee", label: "Rupee" },
  ];
  const campaignType = [
    { value: "choose", label: "Choose" },
    { value: "public_relations", label: "Public Relations" },
    { value: "brand", label: "Brand" },
    { value: "media", label: "Media" },
  ];
 
  const targeyAudience = [
    { value: "small_business", label: "Small Business" },
    { value: "corporate_companies", label: "Corporate Companies" },
    { value: "urban_apartment", label: "Urban Apartment" },
    { value: "business", label: "Business" },
  ];

  return (
    <>
      <>
        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content">
            <div className="row">
              <div className="col-md-12">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row align-items-center">
                    <div className="col-4">
                      <h4 className="page-title">
                      Ringless Campaigns<span className="count-title">123</span>
                      </h4>
                    </div>
                    <div className="col-8 text-end">
                      <div className="head-icons">
                        <CollapseHeader />
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="card">
                  <div className="card-header">
                    {/* Search */}
                    <div className="row align-items-center mb-3">
                      <div className="col-sm-4">
                        <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                         
                          <Link
                            to="#"
                            className="btn btn-primary"
                             data-bs-target="#offcanvas_add"
                          data-bs-toggle="offcanvas"
                          >
                            <i className="ti ti-square-rounded-plus me-2" />
                            Add Campaign
                          </Link>
                        </div>
                      </div>
                    </div>
                    {/* /Search */}
                  </div>
                  <div className="card-body">
                 
                    {/* Contact List */}
                    <div className="table-responsive custom-table">
                      <Table dataSource={data} columns={columns} />
                    </div>
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="datatable-length" />
                      </div>
                      <div className="col-md-6">
                        <div className="datatable-paginate" />
                      </div>
                    </div>
                    {/* /Contact List */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Wrapper */}
      {/* Add New Campaign */}
      <div
          className="offcanvas"
          style={{ width: "1150px", right: "0", top: "0" }}
          tabIndex={-1}
          id="offcanvas_add"
        >
          <div className="offcanvas-header border-bottom">
            <h4>Add Campaign</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div>
                <div className="row">
                  <div className="mb-3 col-md-6">
                    <label className="col-form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-3 col-md-6 ">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows={1}
                      defaultValue={""}
                    />
                  </div>               
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Schedule Time </label>
                    <div>
                      <div className="input-group">
                        <span className="input-group-text ">
                          <i className="ti-user"></i>
                        </span>

                        <input
                          type="time"
                          className="form-select"
                          value="09:30"
                          name="call_time_start"
                          id="timepicker"
                        />
                        <span className="input-group-addon bg-primary text-white b-1 p-2">
                          to
                        </span>
                        <input
                          type="time"
                          className="form-select"
                          value="21:30"
                          name="call_time_end"
                          id="timepicker3"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Country Code </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        className="form-select"
                        name="country_code"
                        id="country_code"
                      >
                        <option value="1">
                          United States &amp; Canada (+1)
                        </option>
                        <option value="44">United Kingdom (+44)</option>
                        <option value="90">Turkey (+90)</option>
                        <option value="41">Switzerland (+41)</option>
                        <option value="46">Sweden (+46)</option>
                        <option value="34">Spain (+34)</option>
                        <option value="27">South Africa (+27)</option>
                        <option value="64">New Zealand (+64)</option>
                        <option value="599">Netherlands Antilles (+599)</option>
                        <option value="39">Italy (+39)</option>
                        <option value="353">Ireland (+353)</option>
                        <option value="852">Hong Kong S.A.R. (+852)</option>
                        <option value="49">Germany (+49)</option>
                        <option value="33">France (+33)</option>
                        <option value="45">Denmark (+45)</option>
                        <option value="55">Brazil (+55)</option>
                        <option value="32">Belgium (+32)</option>
                        <option value="43">Austria (+43)</option>
                        <option value="61">Australia (+61)</option>
                      </select>
                    </div>
                  </div>              
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Caller Id </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="caller_id"
                        className="form-select"
                        id="caller_id"
                      >
                        <option value="custom">Custom</option>
                        <option value="area_code">Area Code</option>
                        <option value="area_code_random">
                          AreaCode And Randomizer
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Custom Caller Id </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        className="form-select"
                        name="custom_caller_id"
                        value=""
                        id="custom-caller-id"
                      >
                        <option value="">Select DID</option>
                        <option data-cnam="test" value="14753159039">
                          14753159039 -test -IVR
                        </option>
                        <option data-cnam="" value="9155335759">
                          9155335759
                        </option>
                        <option data-cnam="" value="9155335769">
                          9155335769
                        </option>
                        <option data-cnam="" value="9155335779">
                          9155335779
                        </option>
                        <option data-cnam="" value="9155335789">
                          9155335789
                        </option>
                        <option data-cnam="Gaurav" value="19028024445">
                          19028024445 -Gaurav -Extension -ab cd - 32222
                        </option>
                        <option data-cnam="Rohit India" value="19027104845">
                          19027104845 -Rohit India -DID +917756966016
                        </option>
                        <option data-cnam="Mr. Lube" value="19024255823">
                          19024255823 -Mr. Lube -IVR
                        </option>
                        <option data-cnam="Raj forwarding" value="15162125295">
                          15162125295 -Raj forwarding -DID +917756966016
                        </option>
                        <option data-cnam="Rohit Canada" value="19029054776">
                          19029054776 -Rohit Canada -DID +917756966016
                        </option>
                        <option data-cnam="Rohit" value="19024412385">
                          19024412385 -Rohit -IVR
                        </option>
                        <option data-cnam="Telnyx Test" value="15166361512">
                          15166361512 -Telnyx Test -Extension
                        </option>
                        <option data-cnam="AI Demo" value="19034377388">
                          19034377388 -AI Demo -Extension
                        </option>
                        <option data-cnam="SunPrint CA" value="19027066999">
                          19027066999 -SunPrint CA -IVR
                        </option>
                        <option data-cnam="Twinning Test" value="13109191294">
                          13109191294 -Twinning Test -Extension -ab cd - 32222
                        </option>
                        <option data-cnam="India" value="16312030323">
                          16312030323 -India -IVR
                        </option>
                        <option data-cnam="Voice blastin" value="16315950959">
                          16315950959 -Voice blastin -IVR
                        </option>
                        <option data-cnam="Rohit Canada" value="15162000091">
                          15162000091 -Rohit Canada -DID +918492042715
                        </option>
                        <option data-cnam="Ashish Odbond" value="16312405683">
                          16312405683 -Ashish Odbond -DID +919896635987
                        </option>
                        <option data-cnam="Shubham" value="16479321367">
                          16479321367 -Shubham -Extension
                        </option>
                        <option data-cnam="Rohit test" value="15168995395">
                          15168995395 -Rohit test -DID 917756966016
                        </option>
                        <option data-cnam="Rohit Wanchoo" value="16313362141">
                          16313362141 -Rohit Wanchoo -Extension -Test Demo App -
                          36706
                        </option>
                        <option data-cnam="Company" value="15168815865">
                          15168815865 -Company -Extension
                        </option>
                        <option data-cnam="Developer Tes" value="16139004832">
                          16139004832 -Developer Tes -DID +919818002784
                        </option>
                        <option data-cnam="Abhishek" value="15168868507">
                          15168868507 -Abhishek -Extension -vj webtrc test -
                          32170
                        </option>
                        <option data-cnam="BuzzClicker" value="18446142007">
                          18446142007 -BuzzClicker -DID 19024412385
                        </option>
                        <option data-cnam="VoIP" value="18882711420">
                          18882711420 -VoIP -DID 16466230005
                        </option>
                        <option data-cnam="Rohit" value="16318176316">
                          16318176316 -Rohit -Extension
                        </option>
                        <option data-cnam="Fax" value="16465533256">
                          16465533256 -Fax -Extension
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Call Duration</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="callduration"
                        className="form-select"
                        id="callduration"
                        
                      >
                        <option value="1">1 min</option>
                        <option value="1">2 min</option>
                        <option value="1">5 min</option>
                        <option value="1">10 min</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Call Ratio</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="callratio"
                        className="form-select"
                        id="callratio"
                        
                      >
                        <option value="1">1</option>
                        <option value="1">2</option>
                        <option value="1">3</option>
                        <option value="1">4</option>
                        <option value="1">5</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6" id="show_predictive_status">
                    <label className="form-label">Status </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <select name="status" className="form-select" id="status">
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Time Zone Rule </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="time_based_calling"
                        className="form-select"
                        id="time_based_calling"
                      >
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">SIP Gateway</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="sipgateway"
                        className="form-select"
                        id="sipgateway"
                        
                      >
                        Select SIP Gateway
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Voice Template</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="voicetemplate"
                        className="form-select"
                        id="voicetemplate"
                        
                      >
                        Select Voice Template
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-primary">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Add New Campaign */}
        {/* Edit Campaign */}
        <div
          className="offcanvas offcanvas-end offcanvas-large"
          tabIndex={-1}
          id="offcanvas_edit"
        >
          <div className="offcanvas-header border-bottom">
            <h4>Edit Campaign</h4>
            <button
              type="button"
              className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <div className="offcanvas-body">
            <form>
              <div className="pro-create">
                <div className="row">
                <div className="mb-3 col-md-6">
                    <label className="col-form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input type="text" className="form-control" />
                  </div>
                  <div className="mb-3 col-md-6 ">
                    <label className="col-form-label">
                      Description <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows={1}
                      defaultValue={""}
                    />
                  </div>               
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Schedule Time </label>
                    <div>
                      <div className="input-group">
                        <span className="input-group-text ">
                          <i className="ti-user"></i>
                        </span>

                        <input
                          type="time"
                          className="form-select"
                          value="09:30"
                          name="call_time_start"
                          id="timepicker"
                        />
                        <span className="input-group-addon bg-primary text-white b-1 p-2">
                          to
                        </span>
                        <input
                          type="time"
                          className="form-select"
                          value="21:30"
                          name="call_time_end"
                          id="timepicker3"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Country Code </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        className="form-select"
                        name="country_code"
                        id="country_code"
                      >
                        <option value="1">
                          United States &amp; Canada (+1)
                        </option>
                        <option value="44">United Kingdom (+44)</option>
                        <option value="90">Turkey (+90)</option>
                        <option value="41">Switzerland (+41)</option>
                        <option value="46">Sweden (+46)</option>
                        <option value="34">Spain (+34)</option>
                        <option value="27">South Africa (+27)</option>
                        <option value="64">New Zealand (+64)</option>
                        <option value="599">Netherlands Antilles (+599)</option>
                        <option value="39">Italy (+39)</option>
                        <option value="353">Ireland (+353)</option>
                        <option value="852">Hong Kong S.A.R. (+852)</option>
                        <option value="49">Germany (+49)</option>
                        <option value="33">France (+33)</option>
                        <option value="45">Denmark (+45)</option>
                        <option value="55">Brazil (+55)</option>
                        <option value="32">Belgium (+32)</option>
                        <option value="43">Austria (+43)</option>
                        <option value="61">Australia (+61)</option>
                      </select>
                    </div>
                  </div>              
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Caller Id </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="caller_id"
                        className="form-select"
                        id="caller_id"
                      >
                        <option value="custom">Custom</option>
                        <option value="area_code">Area Code</option>
                        <option value="area_code_random">
                          AreaCode And Randomizer
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Custom Caller Id </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        className="form-select"
                        name="custom_caller_id"
                        value=""
                        id="custom-caller-id"
                      >
                        <option value="">Select DID</option>
                        <option data-cnam="test" value="14753159039">
                          14753159039 -test -IVR
                        </option>
                        <option data-cnam="" value="9155335759">
                          9155335759
                        </option>
                        <option data-cnam="" value="9155335769">
                          9155335769
                        </option>
                        <option data-cnam="" value="9155335779">
                          9155335779
                        </option>
                        <option data-cnam="" value="9155335789">
                          9155335789
                        </option>
                        <option data-cnam="Gaurav" value="19028024445">
                          19028024445 -Gaurav -Extension -ab cd - 32222
                        </option>
                        <option data-cnam="Rohit India" value="19027104845">
                          19027104845 -Rohit India -DID +917756966016
                        </option>
                        <option data-cnam="Mr. Lube" value="19024255823">
                          19024255823 -Mr. Lube -IVR
                        </option>
                        <option data-cnam="Raj forwarding" value="15162125295">
                          15162125295 -Raj forwarding -DID +917756966016
                        </option>
                        <option data-cnam="Rohit Canada" value="19029054776">
                          19029054776 -Rohit Canada -DID +917756966016
                        </option>
                        <option data-cnam="Rohit" value="19024412385">
                          19024412385 -Rohit -IVR
                        </option>
                        <option data-cnam="Telnyx Test" value="15166361512">
                          15166361512 -Telnyx Test -Extension
                        </option>
                        <option data-cnam="AI Demo" value="19034377388">
                          19034377388 -AI Demo -Extension
                        </option>
                        <option data-cnam="SunPrint CA" value="19027066999">
                          19027066999 -SunPrint CA -IVR
                        </option>
                        <option data-cnam="Twinning Test" value="13109191294">
                          13109191294 -Twinning Test -Extension -ab cd - 32222
                        </option>
                        <option data-cnam="India" value="16312030323">
                          16312030323 -India -IVR
                        </option>
                        <option data-cnam="Voice blastin" value="16315950959">
                          16315950959 -Voice blastin -IVR
                        </option>
                        <option data-cnam="Rohit Canada" value="15162000091">
                          15162000091 -Rohit Canada -DID +918492042715
                        </option>
                        <option data-cnam="Ashish Odbond" value="16312405683">
                          16312405683 -Ashish Odbond -DID +919896635987
                        </option>
                        <option data-cnam="Shubham" value="16479321367">
                          16479321367 -Shubham -Extension
                        </option>
                        <option data-cnam="Rohit test" value="15168995395">
                          15168995395 -Rohit test -DID 917756966016
                        </option>
                        <option data-cnam="Rohit Wanchoo" value="16313362141">
                          16313362141 -Rohit Wanchoo -Extension -Test Demo App -
                          36706
                        </option>
                        <option data-cnam="Company" value="15168815865">
                          15168815865 -Company -Extension
                        </option>
                        <option data-cnam="Developer Tes" value="16139004832">
                          16139004832 -Developer Tes -DID +919818002784
                        </option>
                        <option data-cnam="Abhishek" value="15168868507">
                          15168868507 -Abhishek -Extension -vj webtrc test -
                          32170
                        </option>
                        <option data-cnam="BuzzClicker" value="18446142007">
                          18446142007 -BuzzClicker -DID 19024412385
                        </option>
                        <option data-cnam="VoIP" value="18882711420">
                          18882711420 -VoIP -DID 16466230005
                        </option>
                        <option data-cnam="Rohit" value="16318176316">
                          16318176316 -Rohit -Extension
                        </option>
                        <option data-cnam="Fax" value="16465533256">
                          16465533256 -Fax -Extension
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Call Duration</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="callduration"
                        className="form-select"
                        id="callduration"
                        
                      >
                        <option value="1">1 min</option>
                        <option value="1">2 min</option>
                        <option value="1">5 min</option>
                        <option value="1">10 min</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Call Ratio</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="callratio"
                        className="form-select"
                        id="callratio"
                        
                      >
                        <option value="1">1</option>
                        <option value="1">2</option>
                        <option value="1">3</option>
                        <option value="1">4</option>
                        <option value="1">5</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6" id="show_predictive_status">
                    <label className="form-label">Status </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>
                      <select name="status" className="form-select" id="status">
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Time Zone Rule </label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="time_based_calling"
                        className="form-select"
                        id="time_based_calling"
                      >
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">SIP Gateway</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="sipgateway"
                        className="form-select"
                        id="sipgateway"
                        
                      >
                        Select SIP Gateway
                      </select>
                    </div>
                  </div>
                  <div className="mb-3 col-md-6">
                    <label className="form-label">Voice Template</label>
                    <div className="input-group">
                      <span className="input-group-text ">
                        <i className="ti-user"></i>
                      </span>

                      <select
                        name="voicetemplate"
                        className="form-select"
                        id="voicetemplate"
                        
                      >
                        Select Voice Template
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  data-bs-dismiss="offcanvas"
                  className="btn btn-light me-2"
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-primary">
                  Create
                </button>
              </div>
            </form>
          </div>
        </div>
        {/* /Edit Campaign */}
      </>
      <>
        {/* Delete Campaign */}
        <div className="modal fade" id="delete_campaign" role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="text-center">
                  <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                    <i className="ti ti-trash-x fs-36 text-danger" />
                  </div>
                  <h4 className="mb-2">Remove campaign?</h4>
                  <p className="mb-0">
                    Are you sure you want to remove <br /> campaign you
                    selected.
                  </p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <Link
                      to="#"
                      className="btn btn-light me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to="#"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                    >
                      Yes, Delete it
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Delete Campaign */}

      </>
    </>
  );
};

export default CampaignRingless;